/* eslint-disable max-len */
export var MAX_CHARS = 500;
export var MIN_CHARS = 25;
export var MAX_CHARS_BRA = 5;
export var MIN_CHARS_BRA = 3;
export var BRA_TOOLTIP = 'Your band and cup size — e.g., 36C';
export var EMAIL_TOOLTIP = "Please use the email used to purchase to get OV rewards points. Your email won't be shown on the review and we never share emails with other companies.";
export var SUMMARY_TOOLTIP = "For example: \"Love the fabric!\"";
export var ERRORS = {
  size: 'File is too large',
  type: 'File type not supported',
  invalid: 'File is not valid'
};
export var STANDARD_TIPS = ['Determine whether you would recommend this product', 'Describe the fit for your body type', 'Describe what activities you use this product for'];
export var FOOTWEAR_TIPS = ['Determine whether you would recommend this product', 'Describe the fit', 'Describe what activities you use this product for'];
export var NO_FIT_TIPS = ['Determine if product met your expectations', 'Determine whether you would recommend this product', 'Describe what activities you use this product for'];
export var BRA_PRODUCT_TYPES = ['Bras'];
export var FOOTWEAR_PRODUCT_TYPES = ['Footwear', 'Socks'];
export var NO_FIT_PRODUCT_TYPES = ['3P', 'Accessories', 'Headwear', 'Non-Saleable Merch', 'Nonsellable Merch'];
/* 
Merchandise Hierarchies in NetSuite:

2nd Layer
3P
Accessories
Bodysuit
Bras
Crops
Dresses
Footwear
Headwear
Layers
Leggings
Longsleeve
Non-Saleable Merch
Nonsellable Merch
Outerwear
Pants
Polos
Sample Sale
Shorts
Shortsleeve
Skorts/Skirts
Socks
Swim
Tanks 
*/